const config = document.getElementById('root')?.dataset?.config || '';

export default config;
